"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const SubmitButton = (props) => {
    return ((0, jsx_runtime_1.jsxs)("button", { type: 'submit', className: `btn m-1 btn-primary${props.isLoading ? ' spinner spinner-white spinner-right' : ''}`, onClick: props.onClick, disabled: props.disable, children: [" ", props.name] }));
};
exports.default = SubmitButton;
